import config from 'config';
import { createClient } from 'contentful';

export const contentfulClient = createClient({
  space: config.contentfulSpaceId as string,
  accessToken: config.contentfulAccessToken as string,
});
